import styled from "@emotion/styled";
import { Button, DialogActions, DialogContent } from "@mui/material";
import { StyledDialogTitle } from "components/Dialog/dialog.styles.ts";

export const DeclineLeadButton = styled(Button)(({ theme }) => ({
	backgroundColor: theme.project.colors.fontColors.error,
	border: "1px solid transparent",
	"&:hover": {
		backgroundColor: theme.project.colors.allColors.hex.red.red800
	},
	margin: "0px !important"
}));

export const DeclineLeadModalTitleContainer = styled(StyledDialogTitle)({
	padding: "16px 24px",
	h6: {
		margin: 0
	}
});

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
	padding: "0px 24px 24px 24px",
	display: "flex",
	flexDirection: "column" as const,
	gap: theme.project.layout.gap.large
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
	padding: 0,
	gap: theme.project.layout.gap.medium,
	justifyContent: "flex-end",
	button: {
		flex: 1
	},
	[theme.breakpoints.down("sm")]: {
		flexDirection: "column-reverse" as const,
		alignItems: "center",
		button: {
			width: "100%"
		}
	}
}));
